module.exports = __webpack_public_path__ + "assets/d386d320f047a553526d05d6584716df.mp3";